export default __webpack_public_path__ + "static/media/ios-screen1.003734a2.png";